import { filter } from 'ramda'

import type { Request } from 'app/common/api/requests'
import { BuildingId, OrgDishId, OrgId, WarehouseStockItemId } from 'app/common/types/id'
import { WarehouseStockRequestParams, WarehouseStock } from 'app/common/types/warehouse/stock'

type ParamsDto = {
  school_id?: number
  building_id?: number
  search?: string
  limit?: number
  offset?: number
}

type ResultDto = {
  stock_items: Record<
    string,
    {
      id: number
      item_id: number
      item_title: string
      item_units: string
      quantity: number
      school_id: number
      building_id: number | null
    }
  >
  count: number
}

export const convertParams = ({
  orgId,
  buildingId,
  search,
  limit,
  offset,
}: WarehouseStockRequestParams): [ParamsDto, null] => {
  return [
    filter(Boolean, {
      school_id: orgId ? parseInt(orgId, 10) : undefined,
      building_id: buildingId ? parseInt(buildingId, 10) : undefined,
      search,
      limit,
      offset,
    }),
    null,
  ]
}

export const convertResult = (result: ResultDto): WarehouseStock => {
  return {
    items: Object.values(result.stock_items).map(
      ({
        id,
        item_id: productId,
        item_title: title,
        item_units: unit,
        quantity,
        school_id: schoolId,
        building_id: buildingId,
      }) => ({
        id: String(id) as WarehouseStockItemId,
        productId: String(productId) as OrgDishId,
        title,
        unit,
        quantity,
        orgId: String(schoolId) as OrgId,
        buildingId: buildingId ? (String(buildingId) as BuildingId) : null,
      }),
    ),
    total: result.count,
  }
}

export const GET_WAREHOUSE_STOCK: Request<WarehouseStockRequestParams, WarehouseStock, void> = [
  'food/warehouse/stock',
  'get',
  ['data'],
]
